// @ts-ignore
import zoid from '@krakenjs/zoid/dist/zoid.frameworks';
import {ConfirmPaymentParams, PaymentModalProps} from './types';
import {ComponentOptionsType, MoneiComponent} from '../../types/component';
import {config} from '../config';
import {PaymentResult} from '../types';
import {containerTemplate} from '../container';

export * from './types';

const options: ComponentOptionsType<PaymentModalProps> = {
  tag: 'monei-payment-modal',
  url: config.paymentModalUrl,
  dimensions: {
    width: '100%',
    height: '100%'
  },
  autoResize: {
    width: false,
    height: false
  },
  containerTemplate,
  prerenderTemplate: () => undefined,
  props: {
    paymentId: {
      type: zoid.PROP_TYPE.STRING,
      required: true
    },
    isOpen: {
      type: zoid.PROP_TYPE.BOOLEAN,
      required: true
    },
    language: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    generatePaymentToken: {
      type: zoid.PROP_TYPE.BOOLEAN,
      required: false
    },
    fullscreen: {
      type: zoid.PROP_TYPE.BOOLEAN,
      required: false
    },
    customer: {
      type: zoid.PROP_TYPE.OBJECT,
      required: false
    },
    paymentMethod: {
      type: zoid.PROP_TYPE.OBJECT,
      required: false
    },
    allowedPaymentMethods: {
      type: zoid.PROP_TYPE.ARRAY,
      required: false
    },
    customDomain: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    billingDetails: {
      type: zoid.PROP_TYPE.OBJECT,
      required: false
    },
    shippingDetails: {
      type: zoid.PROP_TYPE.OBJECT,
      required: false
    },
    onResult: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onError: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onLoad: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onOpen: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    style: {
      type: zoid.PROP_TYPE.OBJECT,
      alias: 'innerStyle',
      required: false
    }
  }
};

export const PaymentModal: MoneiComponent<PaymentModalProps> = zoid.create(options);

export const confirmPayment = async (params: ConfirmPaymentParams) => {
  const rootNode = document.createElement('div');
  const bodyOverflow = document.body.style.overflow;
  document.body.appendChild(rootNode);
  return new Promise<PaymentResult>(async (resolve, reject) => {
    const modal = new PaymentModal({
      ...params,
      isOpen: true,
      onOpen: () => {
        Object.assign(document.body.style, {overflow: 'hidden'});
        Object.assign(rootNode.style, {
          position: 'fixed',
          overflow: 'hidden',
          display: 'block',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          width: '100%',
          height: '100%',
          zIndex: 99999
        });
      },
      onResult: (result: any) => {
        resolve(result);
        Object.assign(document.body.style, {overflow: bodyOverflow});
        document.body.removeChild(rootNode);
      },
      onError: (error: any) => {
        reject(error);
        Object.assign(document.body.style, {overflow: bodyOverflow});
        document.body.removeChild(rootNode);
      }
    });
    await modal.render(rootNode);
  });
};
